import React, { useState } from "react";
import * as styles from "./ArticleList.module.scss";
import { Typography, TypographyV2 } from "@components";
import ArticleCard from "@components/ResourceCommomLayout/ArticleCard";
import Button from "@components/Button_new/Button";
import classNames from "classnames";
import { CmsNode } from "@components/CMS/CmsTypes";
import ButtonV2 from "@components/ButtonV2/ButtonV2";

export type ArticleListProps = {
	data: CmsNode[];
	listTitle: string;
	type?: string;
	tabList?: JSX.Element;
	displayNum: number;
	setDisplayNum: (n: number) => void;
};

const ArticleList = ({
	data,
	listTitle,
	type = "blog",
	tabList,
	displayNum,
	setDisplayNum,
}: ArticleListProps) => {

	const [showMore, setShowMore] = useState(false);
	const initialArticles = showMore ? data.slice(0, displayNum) : data.slice(0, 2);

	return (
		<main className={styles.wrapper}>
			<div
				className={classNames(styles.ArticleListContainer, {
					[styles.caseStudyContainer]: type === "studies",
				})}
			>
				<TypographyV2
					variant="HEADING_3"
					color="brand-500"
					className={styles.ArticleListTitle}
				>
					{listTitle}
				</TypographyV2>
				{tabList}
				<div className={styles.articles}>
					{initialArticles.slice(0, displayNum).map((article, i) => (
						<ArticleCard
							key={`article-${i}-${article.title}`}
							data={article}
							mini={true}
						/>
					))}
				</div>
			</div>
		{!showMore && (<div className={styles.button}>
				<Button
					onClick={() => {
						setDisplayNum(displayNum + 5);
						setShowMore(true);
					}}
					className={styles.viewMoreButton}
				>
					Load more
				</Button>
			</div>)}
			
		</main>
	);
};

export default ArticleList;
